import { captureException as captureSentryException } from '@sentry/nextjs';

export const captureException = (exception: any) => {
  captureSentryException(exception);
};
